import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'

export const LoadMoreBtn = ({
  onClick,
  disabled,
}: {
  onClick: () => void
  disabled: boolean
}) => {
  const t = useTranslations('home_v3')
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className="bg-[#333333]/80 text-white border hover:bg-[#333333]/60 transition-all disabled:opacity-50 disabled:cursor-not-allowed px-6 py-2 text-sm font-medium"
    >
      {disabled ? (
        <div className="flex items-center gap-2 text-white">{t('loading')}</div>
      ) : (
        t('load_more')
      )}
    </Button>
  )
}
